import { render, staticRenderFns } from "./ReportImageDamageSimple.vue?vue&type=template&id=11b651ff"
import script from "./ReportImageDamageSimple.vue?vue&type=script&lang=ts"
export * from "./ReportImageDamageSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports